import { render, staticRenderFns } from "./B2bPartnerCreateEditModal.vue?vue&type=template&id=6fbdafbb&"
import script from "./B2bPartnerCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./B2bPartnerCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports